import React, { useEffect } from 'react'
import { InView } from 'react-intersection-observer'
import { usePayPalScriptReducer } from '@paypal/react-paypal-js'
import PayPalMessagingSkeleton from './PayPalMessagingSkeleton'
import * as Styled from './PayPalMessaging.styles'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'

const PayPalMessaging = ({ price }) => {
  const [{ isPending, isResolved, isRejected }] = usePayPalScriptReducer()

  useEffect(() => {
    if (isResolved) {
      window.digitalData.page.attributes.creditOffered.push('paypalin3')
    }
  }, [isResolved])

  const onViewportChange = () => {
    pushEventAndTrack({
      eventInfo: {
        eventName: 'pdp_payPalImpression',
        eventAction: 'Impression'
      }
    })
  }

  if (isRejected) return null

  if (isPending) {
    return (
      <Styled.Wrapper>
        <PayPalMessagingSkeleton />
      </Styled.Wrapper>
    )
  }

  return (
    <InView as='div' onChange={inView => inView && onViewportChange()} threshold={0.5} triggerOnce>
      <Styled.Wrapper>
        <div
          className='paypal-messages'
          data-pp-message
          data-pp-style-layout='text'
          data-pp-style-logo-type='primary'
          data-pp-style-text-color='black'
          data-pp-style-text-size='14'
          data-pp-style-logo-position='left'
          data-pp-amount={price}
        />
      </Styled.Wrapper>
    </InView>
  )
}

export default PayPalMessaging
